export default {
      id: "ic_warning_exclamation-usage",
      viewBox: "0 0 20 19",
      url: "/" + "images/icons.3.109.2.svg#ic_warning_exclamation-usage",
      toString: function () {
        return this.url;
      }
    }